import { IconProps } from '@tabler/icons-react-native'
import { Path, Svg } from 'react-native-svg'

export default function Person({
  size = 24,
  color = 'black',
  ...props
}: IconProps) {
  return (
    <Svg width={size} height={size} viewBox="0 0 16 16" fill="none" {...props}>
      <Path
        d="M12 8.88867C14.2091 8.88867 15.9999 10.8785 16 13.333V16H0V13.333C5.40797e-05 10.8785 1.79089 8.88867 4 8.88867H12Z"
        fill={color}
      />
      <Path
        d="M8 0C10.4546 0 12.4443 1.98979 12.4443 4.44434C12.4443 6.89893 10.4546 8.88867 8 8.88867C5.54545 8.88861 3.55566 6.8989 3.55566 4.44434C3.55572 1.98982 5.54549 5.87547e-05 8 0Z"
        fill={color}
      />
    </Svg>
  )
}
